export default __webpack_public_path__ + "static/media/img-0155-italy-full-face.3d6510da.png";